// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TendersPage from './pages/TendersPage';
import TenderDetailPage from './pages/TenderDetailPage';
import ClientsPage from './pages/ClientsPage';
import ContactsPage from './pages/ContactsPage';
import SourcesPage from './pages/SourcesPage';
import IntelligencePage from './pages/IntelligencePage';
import UsersPage from './pages/UsersPage';

function PrivateRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'var(--text-muted)' }}>
      Loading…
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard"    element={<DashboardPage />} />
            <Route path="tenders"      element={<TendersPage />} />
            <Route path="tenders/:id"  element={<TenderDetailPage />} />
            <Route path="intelligence" element={<IntelligencePage />} />
            <Route path="sources"      element={<SourcesPage />} />
            <Route path="clients"      element={<ClientsPage />} />
            <Route path="contacts"     element={<ContactsPage />} />
            <Route path="users"        element={<PrivateRoute adminOnly><UsersPage /></PrivateRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
